import { dateISOToDateAndTime, personName } from 'Data/format.js'

export function getText(user, date) {
  return `Last updated by ${personName(user?.person) || 'Support'} on ${dateISOToDateAndTime(date)}`
}
